import { useState } from 'react';

import { getPoiLogoUrl } from '@/helpers/common/poiAttribution.helper';

import './poiLogo.scss';

type Props = {
  logoS3: string | null;
  alt: string;
};

/** 32x32 brand logo box, falling back to a placeholder icon when there is no logo or it fails to load. */
export default function PoiLogo({ logoS3, alt }: Readonly<Props>) {
  const [logoError, setLogoError] = useState(false);
  const logoUrl = getPoiLogoUrl(logoS3 ?? undefined);
  const showLogo = !!logoUrl && !logoError;

  return (
    <span className="poiLogo">
      {showLogo ? (
        // biome-ignore lint/a11y/noNoninteractiveElementInteractions: onError is a native img fallback handler
        <img alt={alt} className="poiLogo__image" onError={() => setLogoError(true)} src={logoUrl} />
      ) : (
        <i className="fa-kit-duotone fa-poi-inventory poiLogo__placeholderIcon" />
      )}
    </span>
  );
}
